import React, { useEffect, useState } from "react";
import { Input } from "antd";
import { SearchOutlined } from "@ant-design/icons";
import useDebounce from "../../hooks/useDebounce";

const Search = ({ data, setFiltered, setTotal, handleSearch }) => {
  const [searchText, setSearchText] = useState("");
  const [isChanged, setIsChanged] = useState(false);

  const debouncedSearchText = useDebounce(searchText);

  useEffect(() => {
    if (!isChanged && !debouncedSearchText) return;

    if (handleSearch) handleSearch(debouncedSearchText);
    else handleDefaultSearch();
  }, [debouncedSearchText]);

  const handleDefaultSearch = () => {
    const search = searchText?.toLowerCase();

    const result = data?.filter((item) => {
      const name = item?.user?.name || item?.name || "";
      const email = item?.user?.email || item?.email || "";
      const mobile = item?.mobile_no || "";
      const fileNo = item?.file_number?.toString() || "";

      return (
        (name && name.toLowerCase().includes(search)) ||
        (email && email.toLowerCase().includes(search)) ||
        (mobile && mobile.toLowerCase().includes(search)) ||
        (fileNo && fileNo.toLowerCase().includes(search))
      );
    });

    setFiltered(result);
    if (setTotal) setTotal(result?.length);
  };

  const onChange = (e) => {
    setSearchText(e.target.value);
    if (!isChanged) setIsChanged(true);
  };

  return (
    <div>
      <Input
        placeholder="Search"
        value={searchText}
        onChange={onChange}
        suffix={<SearchOutlined style={{ color: "gray" }} />}
      />
    </div>
  );
};

export default Search;
